export function typedKeys<T>(o: T): (keyof T)[] {
  // type cast should be safe because that's what really Object.keys() does
  // @ts-ignore
  return Object.keys(o) as (keyof T)[];
}

export function formatBytes(bytes: number, decimals = 2) {
  if (!+bytes) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = [
    'Bytes',
    'KiB',
    'MiB',
    'GiB',
    'TiB',
    'PiB',
    'EiB',
    'ZiB',
    'YiB',
  ];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export const groupBy = <T, K extends keyof any>(arr: T[], key: (i: T) => K) =>
  arr.reduce(
    (groups, item) => {
      (groups[key(item)] ||= []).push(item);
      return groups;
    },
    {} as Record<K, T[]>,
  );

export function getInitials(fullName: string): string {
  const [first, last] = fullName.trim().split(' ');
  return ((first?.charAt(0) || '') + (last?.charAt(0) || '')).toUpperCase();
}

/** Plain price amount without thousands grouping: `1150`, `1035,5`. */
export function formatPrice(value: number | undefined | null): string {
  return formatNumberPlain(value);
}

/**
 * Plain number for stats/KPIs, same convention as prices: no grouping, comma decimal,
 * at most 2 decimals (`34,78`, `19730`). Units are appended without a space: `34,78%`, `28h`, `19730€`.
 */
export function formatNumberPlain(value: number | undefined | null): string {
  return new Intl.NumberFormat('sr-RS', {
    useGrouping: false,
    maximumFractionDigits: 2,
  }).format(value ?? 0);
}
